const OPEN_ATTR = 'data-open';
const CLOSE_ATTR = 'data-close';
const POPUP_ATTR = 'data-popup';
const OVERLAY_BOX_ATTR = 'data-overlay-box';
const TOGGLE_ATTR = 'data-toggle';
const TOGGLE_TARGET_ATTR = 'data-toggle-target';
const COPY_LINK_ATTR = 'data-copy-link';
const SHARE_FACEBOOK_ATTR = 'data-share-facebook';
const COPY_TOAST_CLASS = 'c-post__copy-toast';
const COPY_TOAST_VISIBLE_CLASS = 'is-visible';
const OPEN_MODIFIER = 'open';
const VISIBLE_MODIFIER = 'is-active';
const NO_SCROLL_CLASS = 'no-scroll';
const PASSWORD_TOGGLE_CLASS = 'c-account__toggle-password';
const PASSWORD_TOGGLE_VISIBLE_CLASS = 'is-visible';

const getBEMModifier = (element) => {
  const bemClass = Array.from(element.classList).find((cls) => /^(?:l|c|p)-[\w-]+$/.test(cls));
  return bemClass ? `${bemClass}--${OPEN_MODIFIER}` : null;
};

const anyPopupOpen = () => Array.from(document.querySelectorAll(`[${POPUP_ATTR}]`)).some((popup) => {
  const modifier = getBEMModifier(popup);
  return modifier && popup.classList.contains(modifier);
});

const isDrawerOpen = () => {
  const drawer = document.querySelector('.c-drawer');
  return drawer ? drawer.classList.contains(VISIBLE_MODIFIER) : false;
};

const updateScrollLock = () => {
  if (anyPopupOpen() || isDrawerOpen()) {
    document.documentElement.classList.add(NO_SCROLL_CLASS);
  } else {
    document.documentElement.classList.remove(NO_SCROLL_CLASS);
  }
};

const closeAllPopups = () => {
  document.querySelectorAll(`[${POPUP_ATTR}]`).forEach((popup) => {
    const modifier = getBEMModifier(popup);
    if (modifier) {
      popup.classList.remove(modifier);
    }
  });
  document.querySelectorAll(`[${OPEN_ATTR}]`).forEach((trigger) => {
    trigger.classList.remove('is-active');
  });
  updateScrollLock();
};

const togglePopup = (id, open = true) => {
  const popup = document.querySelector(`[${POPUP_ATTR}="${id}"]`);
  if (!popup) {
    return;
  }

  const modifier = getBEMModifier(popup);
  if (!modifier) {
    return;
  }

  const triggers = document.querySelectorAll(`[${OPEN_ATTR}="${id}"]`);

  if (open) {
    closeAllPopups();
    popup.classList.add(modifier);
    popup.setAttribute('aria-hidden', 'false');
    updateScrollLock();
    triggers.forEach(trigger => trigger.classList.add('is-active'));
  } else {
    popup.classList.remove(modifier);
    popup.setAttribute('aria-hidden', 'true');
    updateScrollLock();
    triggers.forEach(trigger => trigger.classList.remove('is-active'));
  }
};

const initPopupTriggers = () => {
  document.body.addEventListener('click', (event) => {
    const openTrigger = event.target.closest(`[${OPEN_ATTR}]`);
    if (openTrigger) {
      const targetId = openTrigger.getAttribute(OPEN_ATTR);
      if (targetId) {
        event.preventDefault();
        togglePopup(targetId, true);
      }
      return;
    }

    const closeTrigger = event.target.closest(`[${CLOSE_ATTR}]`);
    if (closeTrigger) {
      const targetId = closeTrigger.getAttribute(CLOSE_ATTR);
      if (targetId) {
        event.preventDefault();
        togglePopup(targetId, false);
      }
      return;
    }

    const popup = event.target.closest(`[${POPUP_ATTR}]`);
    if (popup && !event.target.closest(`[${OVERLAY_BOX_ATTR}]`)) {
      const popupId = popup.getAttribute(POPUP_ATTR);
      if (popupId) {
        togglePopup(popupId, false);
      }
    }
  });
};

const initToggleTriggers = () => {
  document.body.addEventListener('click', (event) => {
    const toggleTrigger = event.target.closest(`[${TOGGLE_ATTR}]`);
    if (toggleTrigger) {
      const targetId = toggleTrigger.getAttribute(TOGGLE_ATTR);
      if (targetId) {
        event.preventDefault();
        toggleItem(targetId);
      }
    }
  });
};

const showCopyToast = (trigger) => {
  const container = trigger.closest('.c-post__author-right');
  const toast = container ? container.querySelector(`.${COPY_TOAST_CLASS}`) : null;
  if (!toast) {
    return;
  }

  clearTimeout(toast._vbpHideTimeout);
  toast.classList.add(COPY_TOAST_VISIBLE_CLASS);
  toast._vbpHideTimeout = setTimeout(() => {
    toast.classList.remove(COPY_TOAST_VISIBLE_CLASS);
  }, 1800);
};

const initCopyLinkButtons = () => {
  document.body.addEventListener('click', (event) => {
    const shareTrigger = event.target.closest(`[${SHARE_FACEBOOK_ATTR}]`);
    if (shareTrigger) {
      const link = shareTrigger.getAttribute(SHARE_FACEBOOK_ATTR);
      if (link) {
        const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`;
        window.open(shareUrl, '_blank', 'noopener,noreferrer,width=600,height=400');
      }
      return;
    }

    const copyTrigger = event.target.closest(`[${COPY_LINK_ATTR}]`);
    if (copyTrigger) {
      const link = copyTrigger.getAttribute(COPY_LINK_ATTR);
      if (link && navigator.clipboard) {
        navigator.clipboard.writeText(link).then(() => showCopyToast(copyTrigger)).catch(() => {});
      }
    }
  });
};

const SQUARE_CLASS = 'js-height';
const PRODUCT_INFO_TAB_CLASS = 'js-product-info-tab';
const PRODUCT_INFO_BODY_CLASS = 'js-product-info-body';
const PRODUCT_QTY_DECREASE_CLASS = 'js-product-qty-decrease';
const PRODUCT_QTY_INCREASE_CLASS = 'js-product-qty-increase';
const PRODUCT_QTY_VALUE_CLASS = 'js-product-qty-value';
const PRODUCT_QTY_CLASS = 'js-product-qty';
const PRODUCT_VARIANT_OPTS_CLASS = 'js-product-variant-opts';
const PRODUCT_VARIANT_OPT_CLASS = 'js-product-variant-opt';
const PRODUCT_GALLERY_CLASS = 'js-product-gallery';
const PRODUCT_MAIN_IMAGE_CLASS = 'js-product-main-image';
const PRODUCT_THUMBS_CLASS = 'js-product-thumbs';
const PRODUCT_THUMB_CLASS = 'js-product-thumb';
const WIDTH_CLASS = 'js-width';

const updateSquareElements = () => {
  document.querySelectorAll(`.${SQUARE_CLASS}`).forEach((element) => {
    const width = element.getBoundingClientRect().width;
    element.style.height = `${width}px`;
  });

  document.querySelectorAll(`.${WIDTH_CLASS}`).forEach((element) => {
    const height = element.getBoundingClientRect().height;
    element.style.width = `${height}px`;
  });
};

const initProductInfoTabs = () => {
  const tabs = Array.from(document.querySelectorAll(`.${PRODUCT_INFO_TAB_CLASS}`));
  const bodies = Array.from(document.querySelectorAll(`.${PRODUCT_INFO_BODY_CLASS}`));
  if (!tabs.length || !bodies.length) {
    return;
  }

  document.body.addEventListener('click', (event) => {
    const tab = event.target.closest(`.${PRODUCT_INFO_TAB_CLASS}`);
    if (!tab) {
      return;
    }

    const selectedIndex = tabs.indexOf(tab);
    if (selectedIndex === -1) {
      return;
    }

    event.preventDefault();

    tabs.forEach((item, index) => {
      item.classList.toggle(VISIBLE_MODIFIER, index === selectedIndex);
    });

    bodies.forEach((body, index) => {
      body.classList.toggle(VISIBLE_MODIFIER, index === selectedIndex);
    });
  });
};

// Stock cap for the product detail page's quantity control. The cap itself lives on the qty
// root's dataset, kept in sync by product-variants.js's `vbp:variant-stock` event - this module
// only ever reads it, never resolves a variant itself.
const getQtyStockCap = (qtyRoot) => {
  const stock = Number(qtyRoot.dataset.stock);
  return Number.isFinite(stock) ? stock : Infinity;
};

const syncQtyIncreaseState = (qtyRoot) => {
  const qtyValue = qtyRoot.querySelector(`.${PRODUCT_QTY_VALUE_CLASS}`);
  const increaseBtn = qtyRoot.querySelector(`.${PRODUCT_QTY_INCREASE_CLASS}`);
  if (!qtyValue || !increaseBtn) {
    return;
  }
  increaseBtn.disabled = (Number(qtyValue.value) || 0) >= getQtyStockCap(qtyRoot);
};

const initProductQuantity = () => {
  document.body.addEventListener('click', (event) => {
    const decreaseBtn = event.target.closest(`.${PRODUCT_QTY_DECREASE_CLASS}`);
    const increaseBtn = event.target.closest(`.${PRODUCT_QTY_INCREASE_CLASS}`);
    if (!decreaseBtn && !increaseBtn) {
      return;
    }

    event.preventDefault();
    const qtyRoot = (decreaseBtn || increaseBtn).closest(`.${PRODUCT_QTY_CLASS}`);
    if (!qtyRoot) {
      return;
    }

    const qtyValue = qtyRoot.querySelector(`.${PRODUCT_QTY_VALUE_CLASS}`);
    if (!qtyValue) {
      return;
    }

    const current = Number(qtyValue.value.trim()) || 1;
    const next = decreaseBtn ? Math.max(1, current - 1) : Math.min(getQtyStockCap(qtyRoot), current + 1);
    qtyValue.value = String(next);
    syncQtyIncreaseState(qtyRoot);
  });

  document.body.addEventListener('input', (event) => {
    const qtyValue = event.target.closest(`.${PRODUCT_QTY_VALUE_CLASS}`);
    if (!qtyValue) {
      return;
    }
    const qtyRoot = qtyValue.closest(`.${PRODUCT_QTY_CLASS}`);
    const digitsOnly = qtyValue.value.replace(/\D/g, '');
    const cap = qtyRoot ? getQtyStockCap(qtyRoot) : Infinity;
    qtyValue.value = digitsOnly === '' ? '' : String(Math.min(cap, Number(digitsOnly)));
    if (qtyRoot) {
      syncQtyIncreaseState(qtyRoot);
    }
  });

  document.body.addEventListener('blur', (event) => {
    const qtyValue = event.target.closest(`.${PRODUCT_QTY_VALUE_CLASS}`);
    if (!qtyValue) {
      return;
    }
    const qtyRoot = qtyValue.closest(`.${PRODUCT_QTY_CLASS}`);
    const cap = qtyRoot ? getQtyStockCap(qtyRoot) : Infinity;
    qtyValue.value = String(Math.min(cap, Math.max(1, Number(qtyValue.value) || 0)));
    if (qtyRoot) {
      syncQtyIncreaseState(qtyRoot);
    }
  }, true);

  // Fired by product-variants.js whenever the selected variant (or lack thereof) resolves -
  // re-caps the current value down if it now exceeds the newly selected variant's stock.
  document.addEventListener('vbp:variant-stock', (event) => {
    const stock = Number(event.detail && event.detail.stock) || 0;
    document.querySelectorAll(`.${PRODUCT_QTY_CLASS}`).forEach((qtyRoot) => {
      qtyRoot.dataset.stock = String(stock);
      const qtyValue = qtyRoot.querySelector(`.${PRODUCT_QTY_VALUE_CLASS}`);
      if (qtyValue && (Number(qtyValue.value) || 0) > stock) {
        qtyValue.value = String(Math.max(1, stock));
      }
      syncQtyIncreaseState(qtyRoot);
    });
  });
};

const initProductVariants = () => {
  document.body.addEventListener('click', (event) => {
    const option = event.target.closest(`.${PRODUCT_VARIANT_OPT_CLASS}`);
    if (!option) {
      return;
    }

    if (option.classList.contains('is-out')) {
      return;
    }

    const optsGroup = option.closest(`.${PRODUCT_VARIANT_OPTS_CLASS}`);
    if (!optsGroup) {
      return;
    }

    event.preventDefault();
    optsGroup.querySelectorAll(`.${PRODUCT_VARIANT_OPT_CLASS}`).forEach((item) => {
      item.classList.remove(VISIBLE_MODIFIER);
    });
    option.classList.add(VISIBLE_MODIFIER);
  });
};

const initProductGallery = () => {
  const getGalleryRoot = (element) => element.closest(`.${PRODUCT_GALLERY_CLASS}`);

  const setActiveThumb = (thumb, gallery, shouldScroll = true) => {
    const mainImage = gallery.querySelector(`.${PRODUCT_MAIN_IMAGE_CLASS}`);
    const allThumbs = Array.from(gallery.querySelectorAll(`.${PRODUCT_THUMB_CLASS}`));
    if (!mainImage || !thumb || !allThumbs.length) {
      return;
    }

    allThumbs.forEach((item) => item.classList.toggle(VISIBLE_MODIFIER, item === thumb));

    const image = thumb.querySelector('img');
    if (image) {
      mainImage.src = image.src;
      mainImage.alt = image.alt || mainImage.alt;
    }

    if (shouldScroll) {
      thumb.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    }
  };

  const initGalleryState = () => {
    document.querySelectorAll(`.${PRODUCT_GALLERY_CLASS}`).forEach((gallery) => {
      const activeThumb = gallery.querySelector(`.${PRODUCT_THUMB_CLASS}.${VISIBLE_MODIFIER}`) || gallery.querySelector(`.${PRODUCT_THUMB_CLASS}`);
      if (activeThumb) {
        setActiveThumb(activeThumb, gallery, false);
      }
    });
  };

  document.addEventListener('vbp:variant-image', (event) => {
    const attachmentId = event.detail && event.detail.attachmentId;
    if (!attachmentId) {
      return;
    }
    const isUserAction = Boolean(event.detail.isUserAction);

    document.querySelectorAll(`.${PRODUCT_GALLERY_CLASS}`).forEach((gallery) => {
      const thumb = gallery.querySelector(`.${PRODUCT_THUMB_CLASS}[data-attachment-id="${attachmentId}"]`);
      if (thumb) {
        setActiveThumb(thumb, gallery, isUserAction);
      }
    });
  });

  document.body.addEventListener('click', (event) => {
    const thumb = event.target.closest(`.${PRODUCT_THUMB_CLASS}`);
    if (thumb) {
      const gallery = getGalleryRoot(thumb);
      if (!gallery) {
        return;
      }

      event.preventDefault();
      setActiveThumb(thumb, gallery);
      return;
    }

    const prevButton = event.target.closest('.js-product-btn-pre');
    const nextButton = event.target.closest('.js-product-btn-next');
    if (!prevButton && !nextButton) {
      return;
    }

    const gallery = getGalleryRoot(prevButton || nextButton);
    if (!gallery) {
      return;
    }

    const thumbs = Array.from(gallery.querySelectorAll(`.${PRODUCT_THUMB_CLASS}`));
    const activeThumb = gallery.querySelector(`.${PRODUCT_THUMB_CLASS}.${VISIBLE_MODIFIER}`);
    if (!thumbs.length || !activeThumb) {
      return;
    }

    const currentIndex = thumbs.indexOf(activeThumb);
    const targetIndex = prevButton ? Math.max(0, currentIndex - 1) : Math.min(thumbs.length - 1, currentIndex + 1);
    const targetThumb = thumbs[targetIndex];
    if (targetThumb && targetThumb !== activeThumb) {
      event.preventDefault();
      setActiveThumb(targetThumb, gallery);
    }
  });

  initGalleryState();
};

const toggleItem = (id) => {
  const item = document.querySelector(`[${TOGGLE_TARGET_ATTR}="${id}"]`);
  if (!item) {
    return;
  }
  item.classList.toggle(VISIBLE_MODIFIER);

  if (item.classList.contains('c-drawer')) {
    updateScrollLock();
  }

  const allTriggers = document.querySelectorAll(`[${TOGGLE_ATTR}="${id}"]`);
  allTriggers.forEach(t => t.classList.toggle('is-active'));
};

const initPasswordVisibilityToggle = () => {
  document.body.addEventListener('click', (event) => {
    const toggle = event.target.closest(`.${PASSWORD_TOGGLE_CLASS}`);
    if (!toggle) {
      return;
    }

    const input = toggle.previousElementSibling;
    if (!input) {
      return;
    }

    const isVisible = toggle.classList.toggle(PASSWORD_TOGGLE_VISIBLE_CLASS);
    input.type = isVisible ? 'text' : 'password';
    toggle.setAttribute('aria-pressed', String(isVisible));
    toggle.setAttribute('aria-label', isVisible ? 'Ẩn mật khẩu' : 'Hiện mật khẩu');
  });
};

const init = () => {
  initPopupTriggers();
  initToggleTriggers();
  initCopyLinkButtons();
  initProductInfoTabs();
  initProductQuantity();
  initProductVariants();
  initProductGallery();
  initPasswordVisibilityToggle();
  document.querySelectorAll(`[${POPUP_ATTR}]`).forEach((popup) => {
    popup.setAttribute('aria-hidden', 'true');
  });
  updateSquareElements();
  window.addEventListener('resize', updateSquareElements);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

document.querySelectorAll('.js-faq-toggle').forEach(btn => {
  btn.addEventListener('click', () => {
    const item = btn.closest('.js-faq-item');
    const content = item.querySelector('.js-faq-content');

    if (content.classList.contains('is-animating')) return;

    const isOpen = item.classList.contains('is-active');

    content.classList.add('is-animating');

    if (isOpen) {
      // CSS can't transition from height:auto — set an explicit px value first.
      content.style.height = content.scrollHeight + 'px';

      requestAnimationFrame(() => {
        content.style.height = '0px';
      });

      item.classList.remove('is-active');

    } else {
      // Explicit 0px start (not a leftover value) so the transition actually animates.
      content.style.height = '0px';

      requestAnimationFrame(() => {
        content.style.height = content.scrollHeight + 'px';
      });

      item.classList.add('is-active');
    }

    const onEnd = (e) => {
      if (e.target !== content) return;

      content.classList.remove('is-animating');

      if (item.classList.contains('is-active')) {
        content.style.height = 'auto';
      }

      content.removeEventListener('transitionend', onEnd);
    };

    content.addEventListener('transitionend', onEnd);
  });
});

document.querySelectorAll('.js-check-more').forEach((btn) => {
  btn.addEventListener('click', () => {
    const list = btn.previousElementSibling;
    list.classList.toggle('is-collapsed');
    btn.textContent = list.classList.contains('is-collapsed') ? 'Thêm' : 'Thu gọn';
  });
});

const tabs = document.querySelectorAll('.js-auth-tab');
const panels = document.querySelectorAll('.js-auth-panel');
const switches = document.querySelectorAll('.js-auth-switch');

function switchTab(targetId) {
  tabs.forEach(t => t.classList.remove('is-active'));
  panels.forEach(p => p.classList.remove('is-active'));

  const targetPanel = document.getElementById(targetId);
  if (targetPanel) targetPanel.classList.add('is-active');

  tabs.forEach(tab => {
    if (tab.dataset.target === targetId) {
      tab.classList.add('is-active');
    }
  });
}

tabs.forEach(tab => {
  tab.addEventListener('click', () => {
    switchTab(tab.dataset.target);
  });
});

switches.forEach(link => {
  link.addEventListener('click', (e) => {
    e.preventDefault();
    switchTab(link.dataset.target);
  });
});

class MVSlider {
  constructor() {
    this.root = document.querySelector('.js-mv');
    if (!this.root) return;

    this.track = this.root.querySelector('.js-mv-track');
    this.slides = this.root.querySelectorAll('.c-mv__slide-item');
    this.dots = this.root.querySelectorAll('.js-mv-dot');

    this.current = 0;
    this.total = this.slides.length;
    this.interval = null;
    this.isTransitioning = false;

    this.init();
  }

  init() {
    this.cloneSlide();
    this.update();
    this.bindEvents();
    this.autoSlide();
  }

  cloneSlide() {
    const first = this.slides[0].cloneNode(true);
    this.track.appendChild(first);
    this.slides = this.root.querySelectorAll('.c-mv__slide-item');
  }

  update(withTransition = true) {
    if (!withTransition) {
      this.track.style.transition = 'none';
    } else {
      this.track.style.transition = 'transform 0.4s ease';
    }

    this.track.style.transform = `translateX(-${this.current * 100}%)`;

    let realIndex = this.current;
    if (realIndex >= this.total) realIndex = 0;

    this.dots.forEach(dot => dot.classList.remove('is-active'));
    if (this.dots[realIndex]) {
      this.dots[realIndex].classList.add('is-active');
    }
  }

  next() {
    if (this.isTransitioning) return;

    this.current++;
    this.isTransitioning = true;
    this.update();

    // Reached the appended clone slide.
    if (this.current === this.total) {
      setTimeout(() => {
        this.current = 0;
        this.update(false);
        this.isTransitioning = false;
      }, 400);
    } else {
      setTimeout(() => {
        this.isTransitioning = false;
      }, 400);
    }
  }

  goTo(index) {
    this.current = index;
    this.update();
  }

  bindEvents() {
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.goTo(index);
        this.resetAuto();
      });
    });
  }

  autoSlide() {
    this.interval = setInterval(() => {
      this.next();
    }, 2000);
  }

  resetAuto() {
    clearInterval(this.interval);
    this.autoSlide();
  }
}

new MVSlider();

class UserTabs {
  constructor() {
    this.root = document.querySelector('.js-user');
    if (!this.root) return;

    this.tabs = this.root.querySelectorAll('.js-user-tab');
    this.panels = this.root.querySelectorAll('.js-user-panel');

    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        this.setActive(index);
      });
    });
  }

  setActive(index) {
    this.tabs.forEach(tab => tab.classList.remove('is-active'));
    this.panels.forEach(panel => panel.classList.remove('is-active'));

    this.tabs[index].classList.add('is-active');
    this.panels[index].classList.add('is-active');
  }
}

new UserTabs();

class PaymentToggle {
  constructor() {
    this.root = document.querySelector('.js-payment');
    if (!this.root) return;

    this.inputs = this.root.querySelectorAll('.js-payment-input');
    this.bank = this.root.querySelector('.js-payment-bank');

    this.init();
  }

  init() {
    this.bindEvents();
    this.update();
  }

  bindEvents() {
    this.inputs.forEach(input => {
      input.addEventListener('change', () => {
        this.update();
      });
    });
  }

  update() {
    const checked = this.root.querySelector('.js-payment-input:checked');

    if (checked && checked.id === 'pay-bank') {
      this.bank.classList.add('is-active');
    } else {
      this.bank.classList.remove('is-active');
    }
  }
}

new PaymentToggle();